import { useCallback, useRef } from 'react';
type AnyFunction = (...args: any) => any;
export function useDynamicCallback<F extends AnyFunction>(this: ThisParameterType<F>, callback: F) {
  const ref = useRef<F>(undefined);
  ref.current = callback;
  return useCallback((...args: Parameters<F>) => ref.current?.apply(this, args), []);
}